import { Navigate } from 'react-router-dom';

import { FOOTBALL_PLAY_RIVALS_ONBOARDING_CLUB_SELECTION } from '@sorare/core/src/constants/__generated__/routes';

export const Onboarding = () => {
  return <Navigate to={FOOTBALL_PLAY_RIVALS_ONBOARDING_CLUB_SELECTION} />;
};
